import { useQuery } from '@tanstack/react-query';
import { isNil, isNotNil } from '../../../../../utils';
import { screensService } from '../../../../../api';
import type { IScreensLogging } from '../../../../../api/types';
import { queryKey } from '../../../../../constant';
import { useInstanceId } from '../../../../../hooks';

export const useAtomicProxyComponent = (
  url?: string,
  screenLogging?: IScreensLogging,
) => {
  const instanceId = useInstanceId();

  return useQuery({
    queryKey: [...queryKey.proxy(instanceId, url), screenLogging],
    enabled: isNotNil(url),
    queryFn: () => {
      if (isNil(url)) return null;

      return screensService.getProxyComponents({ url, screenLogging });
    },
  });
};
